import axios from "axios";
import React, { useEffect, useState } from "react";
import { faPlus, faEye } from "@fortawesome/free-solid-svg-icons";
import { UserConsumer } from "../../UserContext";
import paginationFactory, {
	PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { Link, useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Table } from "../../components/CustomPaginations";
import {
	statusColor,
	tableStyle,
	TrimString,
	dateCol,
} from "../../components/TableStyle";
import { ItemRequisitionAPI } from "./ItemRequisitionAPI";
import Header from "../../components/Header";
import SubHeader from "../../components/SubHeader";
import FilterationBar from "./common/FilterationBar";
import { AlertPopups } from "../../components/AlertPopups";
import CustomeSearchBar from "../../components/CustomeSearchBar";
import { Button } from "reactstrap";
import moment from "moment";
import {
	GlobalPaginationSize,
	getPaginationSizeOnRole,
} from "../../components/GlobalPaginationSize";
import { APIDateFormat } from "../Dashboard/DashboardVariables";
import { Routes } from "../../configurations/config";

function ItemRequisitionLayout() {
	let token,
		empId,
		empRole,
		empDesignation,
		empDepartment = null;
	let history = useHistory();
	const defaultSorted = [
		{
			dataField: "token",
			order: "desc",
		},
	];
	const [startDate, setStartDate] = useState(
		sessionStorage.getItem("MyItemRequisition")
			? JSON.parse(sessionStorage.getItem("MyItemRequisition"))[1]
				? new Date(
						JSON.parse(
							sessionStorage.getItem("MyItemRequisition")
						)[1]
				  )
				: null
			: null
	);
	const [endDate, setEndDate] = useState(
		sessionStorage.getItem("MyItemRequisition")
			? JSON.parse(sessionStorage.getItem("MyItemRequisition"))[2]
				? new Date(
						JSON.parse(
							sessionStorage.getItem("MyItemRequisition")
						)[2]
				  )
				: null
			: null
	);
	const [searchInput, setSearchInput] = useState(null);
	const [pagerData, setPagerData] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const [statusList, setStatusList] = useState(null);
	const [selectedStatus, setSelectedStatus] = useState(null);
	const [apiHeaderToken, setApiHeaderToken] = useState(null);
	const [numberOfItemsPerPage, setNumberOfItemsPerPage] = useState(
		GlobalPaginationSize.defaultPaginationSize
	);
	const [endDatePickerDisabled, setEndDatePickerDisabled] = useState(
		!startDate
	);
	const [itemRequisitionData, setItemRequisitionData] = useState([]);
	const [pageNum, setPageNum] = useState(1);
	const [sortBy, setSortBy] = useState(defaultSorted[0]);

	const getEmployeeColumns = [
		{
			dataField: "token",
			text: "Token",
			sort: true,
		},
		{
			dataField: "requestedDate",
			text: "Requested Date",
			sort: true,
			formatter: dateCol,
		},
		{
			dataField: "item",
			text: "Item Name",
			sort: true,
			formatter: TrimString,
		},

		{
			dataField: "status",
			text: "Status",
			sort: true,
			style: statusColor,
		},
		{
			dataField: "action",
			text: "Action",
			formatter: (cell, row) => {
				return (
					<div>
						{empDesignation.toString() === "4" &&
						(row.status.toLowerCase() === "forward to cm" ||
						row.status.toLowerCase() === "cm approved") ? ( //Jibran
							<Link
								to={{
									pathname: `${Routes.SSNItemRequisitionDetail}/${row.token}`,
									state: { itemStatus: row.status },
								}}
							>
								<button
									className="btnStyle"
									title="View Detail"
								>
									<FontAwesomeIcon
										id="edit"
										className="hoverEffect"
										icon={faEye}
										size="1x"
									/>
								</button>
							</Link>
						) : (
							<Link
								to={{
									pathname: `${Routes.ItemRequisitionDetail}/${row.token}`,
									state: {
										itemStatus: row.status,
									},
								}}
							>
								<button
									className="btnStyle"
									title="View Detail"
								>
									<FontAwesomeIcon
										id="edit"
										className="hoverEffect"
										icon={faEye}
										size="1x"
									/>
								</button>
							</Link>
						)}
					</div>
				);
			},
		},
	];
	const getSSNColumns = [
		{
			dataField: "token",
			text: "Token",
			sort: true,
		},
		{
			dataField: "item",
			text: "Item Name",
			sort: true,
			title:true,
			formatter: TrimString,
		},
		{
			dataField: "requestedBy",
			text: "Requested By",
			sort: true,
		},
		{
			dataField: "status",
			text: "Status",
			sort: true,
			headerStyle: {
				width: "20%",
			},
			style: statusColor,
		},
		{
			dataField: "action",
			text: "Action",
			formatter: (cell, row) => {
				return (
					<div>
						{row.status.toLowerCase() !== "pending" ? (
							<Link
								to={{
									pathname: `${Routes.SSNItemRequisitionDetail}/${row.token}`,
									state: { itemStatus: row.status },
								}}
							>
								<button
									className="btnStyle"
									title="View Detail"
								>
									<FontAwesomeIcon
										id="edit"
										className="hoverEffect"
										icon={faEye}
										size="1x"
									/>
								</button>
							</Link>
						) : (
							<Link
								to={{
									pathname: `${Routes.ItemRequisitionDetail}/${row.token}`,
									state: { itemStatus: row.status },
								}}
							>
								<button
									className="btnStyle"
									title="View Detail"
								>
									<FontAwesomeIcon
										id="edit"
										className="hoverEffect"
										icon={faEye}
										size="1x"
									/>
								</button>
							</Link>
						)}
					</div>
				);
			},
		},
	];
	useEffect(() => {
		let pageSize = getPaginationSizeOnRole(empDesignation);
		setNumberOfItemsPerPage(pageSize);

		const tokenHeader = {
			Authorization: `Bearer ${token}`,
		};
		setApiHeaderToken(tokenHeader);
		axios
			.get(
				`${ItemRequisitionAPI.GetItemRequisitionPagination}?Status=${
					sessionStorage.getItem("MyItemRequisition")
						? JSON.parse(
								sessionStorage.getItem("MyItemRequisition")
						  )[0]
							? JSON.parse(
									sessionStorage.getItem("MyItemRequisition")
							  )[0].value
							: 0
						: 0
				}&StartDate=${
					sessionStorage.getItem("MyItemRequisition")
						? JSON.parse(
								sessionStorage.getItem("MyItemRequisition")
						  )[1]
							? moment(startDate).format("YYYY-MM-DD")
							: ""
						: ""
				}&EndDate=${
					sessionStorage.getItem("MyItemRequisition")
						? JSON.parse(
								sessionStorage.getItem("MyItemRequisition")
						  )[2]
							? moment(endDate).format("YYYY-MM-DD")
							: ""
						: ""
				}&PageSize=${numberOfItemsPerPage}&SortBy=${sortBy.dataField}_${
					sortBy.order
				}`,
				{
					headers: tokenHeader,
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setItemRequisitionData(res.data.itemRequisitions);
				}
			});
		//For supervisor //get status
		axios
			.get(`${ItemRequisitionAPI.GetItemRequisitionStatusTypes}`, {
				headers: tokenHeader,
			})
			.then(({ status, data }) => {
				if (status === 200) {
					if (sessionStorage.getItem("MyItemRequisition")) {
						let status = JSON.parse(
							sessionStorage.getItem("MyItemRequisition")
						)[0];
						if (status) setSelectedStatus(status);
						else setSelectedStatus({ value: 0, label: "All" });
					} else setSelectedStatus({ value: 0, label: "All" });
					let statusList = data.types.filter(
						(item) => item.label != "All"
					);
					let sorted = statusList.sort((a, b) =>
						a.label.localeCompare(b.label)
					);
					sorted.unshift({ value: 0, label: "All" });
					setStatusList(sorted);
				}
			});
	}, []);

	const filterOnDateChange = (StartDate, EndDate) => {
		setIsLoading(true);
		let apiURL = "";
		const startDateFormated = moment(StartDate).format(APIDateFormat);
		const endDateFormated = moment(EndDate).format(APIDateFormat);

		if (searchInput === "" || searchInput === null) {
			apiURL = `${ItemRequisitionAPI.GetItemRequisitionPagination}?StartDate=${startDateFormated}&EndDate=${endDateFormated}&PageSize=${numberOfItemsPerPage}&Status=${selectedStatus.value}&SortBy=${sortBy.dataField}_${sortBy.order}`;
		} else {
			apiURL = `${ItemRequisitionAPI.GetItemRequisitionPagination}?StartDate=${startDateFormated}&EndDate=${endDateFormated}&PageSize=${numberOfItemsPerPage}&Status=${selectedStatus.value}&SortBy=${sortBy.dataField}_${sortBy.order}&SearchTerm=${searchInput}`;
		}
		axios
			.get(apiURL, {
				headers: apiHeaderToken,
			})
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPageNum(1);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setItemRequisitionData(res.data.itemRequisitions);
				}
			})
			.catch((err) => {
				if (err.response) {
					AlertPopups.ErrorAlert.fire({
						text: `Item Requisition ${err.response.data.message}`,
					});
				}
			});
	};
	const onStatusChange = (status) => {
		setIsLoading(true);
		let apiURL = "";
		if (searchInput === "" || searchInput === null) {
			if (startDate) {
				const startDateFormated =
					moment(startDate).format(APIDateFormat);
				const endDateFormated = moment(endDate).format(APIDateFormat);
				apiURL = `${ItemRequisitionAPI.GetItemRequisitionPagination}?PageSize=${numberOfItemsPerPage}&SortBy=${sortBy.dataField}_${sortBy.order}&StartDate=${startDateFormated}&EndDate=${endDateFormated}&Status=${status.value}`;
			} else {
				apiURL = `${ItemRequisitionAPI.GetItemRequisitionPagination}?PageSize=${numberOfItemsPerPage}&SortBy=${sortBy.dataField}_${sortBy.order}&Status=${status.value}`;
			}
		} else {
			if (startDate) {
				const startDateFormated =
					moment(startDate).format(APIDateFormat);
				const endDateFormated = moment(endDate).format(APIDateFormat);
				apiURL = `${ItemRequisitionAPI.GetItemRequisitionPagination}?PageSize=${numberOfItemsPerPage}&SortBy=${sortBy.dataField}_${sortBy.order}&StartDate=${startDateFormated}&EndDate=${endDateFormated}&Status=${status.value}&SearchTerm=${searchInput}`;
			} else {
				apiURL = `${ItemRequisitionAPI.GetItemRequisitionPagination}?PageSize=${numberOfItemsPerPage}&SortBy=${sortBy.dataField}_${sortBy.order}&Status=${status.value}&SearchTerm=${searchInput}`;
			}
		}

		axios
			.get(apiURL, {
				headers: apiHeaderToken,
			})
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPageNum(1);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setItemRequisitionData(res.data.itemRequisitions);
				}
			})
			.catch((err) => {
				if (err.response) {
					AlertPopups.ErrorAlert.fire({
						text: `Item Requisition ${err.response.data.message}`,
					});
				}
			});
	};

	const receiveData = (PageSize) => {
		setIsLoading(true);
		let apiURL = "";
		if (searchInput === "" || searchInput === null) {
			if (startDate) {
				const startDateFormated =
					moment(startDate).format(APIDateFormat);
				const endDateFormated = moment(endDate).format(APIDateFormat);
				apiURL = `${
					ItemRequisitionAPI.GetItemRequisitionPagination
				}?PageSize=${PageSize}&PageNumber=${1}&SortBy=${
					sortBy.dataField
				}_${
					sortBy.order
				}&StartDate=${startDateFormated}&EndDate=${endDateFormated}&Status=${
					selectedStatus.value
				}`;
			} else {
				apiURL = `${
					ItemRequisitionAPI.GetItemRequisitionPagination
				}?PageSize=${PageSize}&PageNumber=${1}&SortBy=${
					sortBy.dataField
				}_${sortBy.order}&Status=${selectedStatus.value}`;
			}
		} else {
			if (startDate) {
				const startDateFormated =
					moment(startDate).format(APIDateFormat);
				const endDateFormated = moment(endDate).format(APIDateFormat);
				apiURL = `${
					ItemRequisitionAPI.GetItemRequisitionPagination
				}?PageSize=${PageSize}&PageNumber=${1}&SortBy=${
					sortBy.dataField
				}_${
					sortBy.order
				}&StartDate=${startDateFormated}&EndDate=${endDateFormated}&Status=${
					selectedStatus.value
				}&SearchTerm=${searchInput}`;
			} else {
				apiURL = `${
					ItemRequisitionAPI.GetItemRequisitionPagination
				}?PageSize=${PageSize}&PageNumber=${1}&SortBy=${
					sortBy.dataField
				}_${sortBy.order}&Status=${
					selectedStatus.value
				}&SearchTerm=${searchInput}`;
			}
		}
		axios
			.get(apiURL, {
				headers: apiHeaderToken,
			})
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPageNum(1);
					setNumberOfItemsPerPage(PageSize);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setItemRequisitionData(res.data.itemRequisitions);
				}
			});
	};
	const handleTableChange = (type, { page, sortOrder, sortField }) => {
		setIsLoading(true);
		let getData = false;

		let apiCall = `${
			ItemRequisitionAPI.GetItemRequisitionPagination
		}?PageSize=${numberOfItemsPerPage}&PageNumber=${page}&Status=${
			selectedStatus.value
		}&SortBy=${type === "sort" ? sortField : sortBy.dataField}_${
			type === "sort" ? sortOrder : sortBy.order
		}${
			startDate
				? "&StartDate=" +
				  moment(startDate).format(APIDateFormat) +
				  "&EndDate=" +
				  moment(endDate).format(APIDateFormat)
				: ""
		}${
			searchInput === "" || searchInput === null
				? ""
				: "&SearchTerm=" + searchInput
		}`;

		if (type === "sort") {
			getData = true;
			setSortBy({ dataField: sortField, order: sortOrder });
		} else if (type === "pagination") {
			getData = true;
		}

		if (getData) {
			axios
				.get(apiCall, {
					headers: apiHeaderToken,
				})
				.then((res) => {
					if (res.status === 200) {
						setIsLoading(false);
						setPageNum(page);
						setPagerData(JSON.parse(res.headers["x-pagination"]));
						setItemRequisitionData(res.data.itemRequisitions);
					}
				});
		}
	};
	const handleSearch = (event) => {
		setPageNum(1);
		setIsLoading(true);
		const value = event.target.value;
		setSearchInput(value);

		let apiCall = `${
			ItemRequisitionAPI.GetItemRequisitionPagination
		}?PageSize=${numberOfItemsPerPage}&PageNumber=${1}&Status=${
			selectedStatus.value
		}&SortBy=${sortBy.dataField}_${sortBy.order}${
			startDate
				? "&StartDate=" +
				  moment(startDate).format(APIDateFormat) +
				  "&EndDate=" +
				  moment(endDate).format(APIDateFormat)
				: ""
		}${value === "" || value === null ? "" : "&SearchTerm=" + value}`;

		axios
			.get(apiCall, {
				headers: apiHeaderToken,
			})
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setItemRequisitionData(res.data.itemRequisitions);
				}
			});
	};
	const storeFiltersStates = (value, property) => {
		let obj = [];
		if (sessionStorage.getItem("MyItemRequisition"))
			obj = JSON.parse(sessionStorage.getItem("MyItemRequisition"));
		if (property === "status") obj[0] = value;
		else if (property === "startDate") obj[1] = value;
		else if (property === "endDate") obj[2] = value;
		sessionStorage.setItem("MyItemRequisition", JSON.stringify(obj));
	};

	const rowEvents = {
		onClick: (e, row) => {
			if (
				(empDesignation.toString() === "4" &&
				(row.status.toLowerCase() === "forward to cm" ||
					row.status.toLowerCase() === "cm approved")) || 
					(empDepartment.toString() === "3" && row.status.toLowerCase() !== "pending")
			) {
				//Jibran
				history.push({
					pathname: `${Routes.SSNItemRequisitionDetail}/${row.token}`,
					state: { itemStatus: row.status },
				});
			} else {
				history.push({
					pathname: `${Routes.ItemRequisitionDetail}/${row.token}`,
					state: {
						itemStatus: row.status,
					},
				});
			}
		},
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				empId = userDetails.id;
				empRole = userDetails.empRole;
				empDesignation = userDetails.designation;
				empDepartment = userDetails.department;
				return (
					<>
						<div className="container-fluid pl-3 pr-3">
							<Header
								title="Item Requisition"
								headerBorder="false"
							/>

							<SubHeader
								btnTitle="Create New"
								icon={faPlus}
								linkTo={Routes.CreateItemRequisition}
							/>
							{empId === "40" || //uzma
							empRole.includes("3") ? (
								//Asif
								<>
									<Link to={Routes.ItemRequisitionClasses}>
										<Button className="primaryButton btn btn-secondary mr-3">
											Classes
										</Button>
									</Link>
									<Link to={Routes.ItemRequisitionCategories}>
										<Button className="primaryButton btn btn-secondary mr-3">
											Categories
										</Button>
									</Link>
									<Link to={Routes.ItemRequisitionVendors}>
										<Button className="primaryButton btn btn-secondary">
											Vendors
										</Button>
									</Link>
								</>
							) : null}

							<FilterationBar
								statusList={statusList}
								selectedStatus={selectedStatus}
								onStatusChange={(value) => {
									setSelectedStatus(value);
									onStatusChange(value);
									storeFiltersStates(value, "status");
								}}
								startDate={startDate}
								endDate={endDate}
								endDatePickerDisabled={endDatePickerDisabled}
								onStartDateChange={(startDate) => {
									setStartDate(startDate);
									storeFiltersStates(startDate, "startDate");
									//if user select start date again after selecting end date(when end date is enabled)
									if (endDate) {
										filterOnDateChange(startDate, endDate);
									} else {
										setEndDatePickerDisabled(false);
									}
								}}
								onEndDateChange={(endDate) => {
									setEndDate(endDate);
									filterOnDateChange(startDate, endDate);
									storeFiltersStates(endDate, "endDate");
								}}
							/>

							<CustomeSearchBar
								handleSearch={(event) => handleSearch(event)}
								tooltip={
									"Search by token, name, requested by and status"
								}
							/>

							<PaginationProvider
								pagination={paginationFactory({
									custom: true,
									totalSize: pagerData
										? pagerData.TotalCount
										: 0,
									page: pageNum,
									sizePerPage: numberOfItemsPerPage,
									paginationSize: numberOfItemsPerPage,
								})}
							>
								{({
									paginationProps,
									paginationTableProps,
								}) => {
									return (
										<Table
											inputValue={searchInput}
											keyField={"token"}
											columns={
												empId === "79" ||
												empId === "40" ||
												empId === "33" ||
												empRole.includes("3") ||
												userDetails.department.toString() ===
													"3"
													? getSSNColumns
													: getEmployeeColumns
											}
											items={itemRequisitionData}
											tableStyle={tableStyle}
											paginationProps={paginationProps}
											paginationTableProps={
												paginationTableProps
											}
											onTablePageChange={
												handleTableChange
											}
											defaultSorted={defaultSorted}
											showFeedback={false}
											tableLoader={isLoading}
											SearchBar={() => {
												return null;
											}}
											pagerData={pagerData}
											receiveData={(PageSize) => {
												receiveData(PageSize);
											}}
											rowEvents={rowEvents}
										/>
									);
								}}
							</PaginationProvider>
						</div>
					</>
				);
			}}
		</UserConsumer>
	);
}

export default ItemRequisitionLayout;
